import { Locales } from '@ratehub/base-ui';
import { PAGE_TEMPLATES } from '@ratehub/web-components';

import BLOCK_MAP from '../definitions/TemplateInsuranceBlockMap';
import withEnglishLocale from '../functions/withEnglishLocale';
import createWordpressPageStaticProps from '../functions/createWordpressPageStaticProps';
import createStaticWordpressPage from '../functions/createStaticWordpressPage';


const { getStaticPaths, getStaticProps } = createWordpressPageStaticProps({
    locale: Locales.ENGLISH,
    fileName: 'wordpressInsuranceEN', // Must match filename use for catch all, i.e. [...ccDetailsSlugEN].jsx
    blockMap: BLOCK_MAP,
    template: PAGE_TEMPLATES.insurance,
});

const page = createStaticWordpressPage({ blockMap: BLOCK_MAP });

export default withEnglishLocale(page);
export { getStaticPaths, getStaticProps, BLOCK_MAP };
